import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
//        Title: () => <span> Lin and Brian are celebrating their wedding!</span>,
            Details: () => (
                <>
                    <p>
                Please click <a href="https://docs.google.com/forms/d/e/1FAIpQLSdKKN3FIAx2Lq-8tDpp9jLH4ecvir7gaOofx7v6uUWKuJiHcw/viewform?usp=dialog">here</a> to RSVP.
                    </p>
                </>
            ),
//        Date: () => (
//            <div className="d-flex flex-column">
//                <div>
//                    <span>
//                       10/28/2025
//                    </span>
//                </div>
//            </div>
//        ),
//        Location: () => <span>Kaomai Lanna Resort, Chiang Mai, Thailand</span>,
//        locationLink: "https://maps.app.goo.gl/9MHyt8CSNGa1ozVe9",
    },
    [LANGUAGE.ZH]: {
//        Title: () => <span>毛琳和布莱恩的婚礼要来啦！</span>,
            Details: () => (
                <>
                    <p>
                点击<a href="https://docs.google.com/forms/d/e/1FAIpQLSdKKN3FIAx2Lq-8tDpp9jLH4ecvir7gaOofx7v6uUWKuJiHcw/viewform?usp=dialog">此处</a>回复。
                    </p>
                </>
            ),
//        Date: () => (
//            <div className="d-flex flex-column">
//                <div>
//                    <span>
//                       2025年10月28日 
//                    </span>
//                </div>
//            </div>
//        ),
//        Location: () => <span>清迈高迈兰纳度假酒店</span>,
//        locationLink: "https://surl.amap.com/16ymesVx13W",
    },
}
